import { onDestroy } from 'svelte';

// Copied from Svelte doc: https://svelte.dev/tutorial/ondestroy
export function onInterval(callback, milliseconds) {
  const interval = setInterval(callback, milliseconds);
  onDestroy(() => {
    clearInterval(interval);
  });
}

let urlInText = new RegExp(
  '([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?',
);

export const containsLink = (content) => {
  return content.match(urlInText);
};

export const setLink = (content) => {
  let urlLink;
  let preUrl = '';
  const urlArray = content.match(urlInText);
  if (urlArray && urlArray[0]) {
    if (urlArray[0].indexOf('http') === -1) {
      preUrl = '//' + urlArray[0];
      urlLink = urlArray[0].link(preUrl);
    } else {
      urlLink = urlArray[0].link(urlArray[0]);
    }
    return content.replace(urlArray[0], urlLink.split('<a').join('<a target="_blank"'));
  }
  return content;
};

export const getCategoryDisplayName = (categories, category) => {
  if (category) {
    const type = categories.find((c) => c.type === category);
    return type ? type.displayName : 'TV 2-chat';
  } else {
    return 'TV 2-chat';
  }
};

export const parseUserId = (id) => {
  if (!id) return '';

  if (id.includes('sumo')) {
    const userId = id.split('sumo:')[1];

    if (userId.includes('undefined')) {
      return 'Anonym';
    }

    return userId;
  }

  return 'Anonym';
};
